module.exports = __webpack_public_path__ + "img/classic_rental40_4.f342bb57.jpg";